<template>
  <div class="panel-content" v-if="currItem.screen_text">
    <div class="example" v-if="!isSPC">
      {{ currItem.is_example ? $t('hsk_example') : currItem.index }}
    </div>
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>

    <div class="score-content" v-if="isShowScores">
      {{ $t('evaluate_common_total_score') }}:
      <span :style="{ color: currItem.scores / currItem.score >= 0.8 ? '#09cba0' : '#fc5a5a' }">{{
        isMarked == 2 ? currItem.scores : '-'
      }}</span
      >{{ `/${currItem.score}` }}
    </div>
    <div class="panel-content-text" v-if="currItem.topic_type != 'kw'">
      <template>
        <p class="question_require">
          {{ currItem.topic_type == 'pa' ? currItem.screen_text[0].content : '' }}
        </p>
        <img
          v-for="(item, index) in imageScreenText"
          :key="index"
          :src="baseUrl + item.content + '?width=300'"
          alt=""
        />
      </template>
      <template v-if="currItem.topic_type == 'ms'">
        <p v-for="(item, index) in currItem.screen_text" :key="index" v-if="item.type == 'text'">
          {{ item.content }}
        </p>
      </template>
    </div>
    <div class="panel-content-keytext" v-if="currItem.topic_type == 'kw'">
      <p class="question_require">{{ currItem.screen_text[0].content }}</p>
      <div class="keywords">
        <div class="keywords-flex">
          <div class="keywords-text" v-for="(item, index) in keywordsdetail" :key="index">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
    <div class="panel-content-input">
      <el-input
        v-if="isExamMode"
        type="textarea"
        :rows="4"
        :placeholder="inputPlaceholder"
        v-model="inputText"
        :maxlength="limitLength"
        @input="textInput"
        :disabled="currItem.is_example"
      >
      </el-input>
      <p v-if="!isExamMode" class="limit">{{ wordLengthUnExamMode }}/{{ limitShowLength }}</p>
      <p v-if="isExamMode" class="limit">{{ wordLength }}/{{ limitShowLength }}</p>
      <div v-else class="input-box" v-html="currItem.answer || inputText"></div>
    </div>
    <div class="panel-content-result" v-if="!isExamMode && !currItem.is_example">
      <p class="orange">{{ $t('hsk_reference_answer') }}</p>
      <p class="correct-answer">
        {{ answerText }}
      </p>
    </div>
    <div class="correct-box" v-if="!isExamMode && analysisText && !currItem.is_example">
      <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
      <p class="correct-box-answer">
        {{ analysisText }}
      </p>
    </div>
  </div>
</template>

<script>
import QuestionDescription from '@/components/hsk/questionDescription'
import { getAllWordsLength } from '@/utils/utils'
export default {
  components: { QuestionDescription },
  data() {
    return {
      inputText: '',
      keywordsdetail: [],
      blankNum: 0,
    }
  },
  computed: {
    language() {
      let local = localStorage.getItem('language')
      if (local == 'zh') {
        return 'cn'
      } else {
        return local
      }
    },
    analysisText() {
      return this.currItem.analysis
        ? this.currItem.analysis[this.language]
          ? this.currItem.analysis[this.language]
          : this.currItem.analysis['zh']
        : ''
    },
    answerText() {
      return this.currItem.evaluate.standard_answer[0]
    },
    imageScreenText() {
      return this.currItem.screen_text.filter((item) => {
        return item.type == 'image'
      })
    },
    limitLength() {
      if (this.currItem.topic_type == 'ms') {
        return 50 + this.blankNum
      } else {
        return 100 + this.blankNum
      }
    },
    limitShowLength() {
      if (this.currItem.topic_type == 'ms') {
        return 50
      } else {
        return 100
      }
    },
    inputPlaceholder() {
      if (this.currItem.topic_type == 'ms') {
        return this.$t('write_word_sentence')
      } else if (this.currItem.topic_type == 'kw') {
        return this.$t('write_word_artical')
      } else {
        return this.$t('write_img_artical')
      }
    },
    isShowScores() {
      return !this.currItem.is_example && !this.isExamMode && !this.$route.query?.ifRecord
    },
    wordLength() {
      return getAllWordsLength(this.inputText)
    },
    wordLengthUnExamMode() {
      return getAllWordsLength(this.currItem.answer.length || this.inputText.length)
    },
  },
  watch: {
    currItem: {
      handler(val) {
        console.log('val===', val)
        if (val.screen_text && val.screen_text.length > 0) {
          this.keywordsdetail = val.screen_text?.[1].content?.split(' ')
          if (val.answer) {
            if (!this.isExamMode) {
              val.answer = this.changeColor(val.answer, this.keywordsdetail)
            } else {
              this.inputText = val.answer
            }
          } else {
            if (this.currItem.is_example) {
              this.inputText = this.isExamMode
                ? val.evaluate.standard_answer[0]
                : this.changeColor(val.evaluate.standard_answer[0], this.keywordsdetail)
            } else {
              this.inputText = ''
            }
          }
          console.log(this.inputText)
        }
      },
      immediate: true,
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    baseUrl: {
      type: String,
      default: '',
    },
    // 批改状态
    isMarked: {
      type: Number,
    },
    isSPC: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    //输入框监听
    textInput(e) {
      this.inputText = e
      let inputText = e.replace(/\ +/g, '')
      inputText = inputText.replace(/[\r\n]/g, '')
      // if (inputText.length > 8) {
      //   layer.msg('超了')
      // }
      this.blankNum = e.length - inputText.length
      this.textChange()
    },
    //失焦暂存
    textChange() {
      // let key_words_must = this.currItem.evaluate.key_words_must;
      // let provide_words = this.currItem.evaluate.provide_words;
      // let mustWords = key_words_must.concat(provide_words);
      // let answerLength = this.currItem.evaluate.length.split("-");
      // answerLength = answerLength.map((item) => {
      //   item = parseInt(item);
      //   return item;
      // });
      // console.log(answerLength);
      let ansObj = {
        questionId: this.currItem.index,
        answer: this.inputText,
        judge: 0,
        scores: null,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        topic_type: this.currItem.topic_type,
        evaluate: {
          category: this.currItem.evaluate.category,
          answer: this.inputText,
          full_marks: this.currItem.score,
          reference_answer: JSON.stringify(this.currItem.evaluate.standard_answer),
          // answer_length_range: JSON.stringify(answerLength),
          // keywords: JSON.stringify(mustWords),
          unnecessary_keywords: JSON.stringify(this.currItem.evaluate.key_words_optional),
          original_text: '',
          questionId: this.currItem.index,
        },
      }
      console.log(ansObj)
      setTimeout(() => {
        this.$emit('saveRes', ansObj)
      })
    },
    changeColor(result, keywords) {
      keywords.map((keyitem, keyindex) => {
        if (keyitem && keyitem.length > 0) {
          // 匹配关键字正则
          let replaceReg = new RegExp(keyitem, 'g') // 高亮替换v-html值
          let replaceString =
            '<span class="highlight"' + ' style="color: #1C84FE' + ';">' + keyitem + '</span>'
          result = result.replace(replaceReg, replaceString)
        }
      })

      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.panel-content {
  width: 100%;
  padding: 0px 29px 20px 29px;
  position: relative;
  .example {
    background: rgba(63, 70, 81, 1);
    border-radius: 4px;
    color: #fff;
    padding: 5px;
    font-size: 12px;
    position: absolute;
    top: 70px;
    left: 28px;
    min-width: 20px;
    display: flex;
    justify-content: center;
  }
  .score-content {
    position: absolute;
    right: 23px;
    top: 16px;
  }
  .question_description {
    position: absolute;
    left: 30px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #1c84fe;
    margin-top: 0px;
  }
  .question_require {
    position: absolute;
    left: 0px;
    top: 45px;
    font-size: 12px;
    font-weight: 400;
    color: #3f4651;
    margin-top: 0px;
  }
  &-text {
    width: 100%;
    display: flex;
    padding-top: 60px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    img {
      width: 280px;
      height: 156px;
      border-radius: 4px;
      margin-top: 10px;
      object-fit: contain;
    }
    p {
      font-size: 22px;
      font-weight: 600;
      color: #3f4651;
      margin-top: 32px;
    }
  }
  &-keytext {
    width: 100%;
    padding-top: 40px;
    position: relative;
    .keywords {
      width: 100%;
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &-flex {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }
      &-text {
        font-size: 22px;
        font-weight: 600;
        color: #3f4651;
        margin: 0px 15px;
      }
    }
  }
  &-input {
    margin: 50px 0px 40px 0px;
    position: relative;
    .limit {
      position: absolute;
      bottom: 5px;
      right: 5px;

      font-size: 12px;
      font-weight: 400;
      color: #c6cad4;
    }
    .input-box {
      padding: 5px 15px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      font-size: 14px;
      min-height: 100px;
      line-height: 21px;
    }
  }
  &-result {
    width: 100%;
    border-top: 1px dashed #e6eaef;
    padding: 30px 0px;
    .correct-answer {
      font-size: 14px;
      color: #545961;
      margin-top: 20px;
    }
    .orange {
      font-size: 14px;
      font-weight: 500;
      color: #fc5a5a;
    }
  }
  .correct-box {
    background: rgba(251, 252, 255, 1);
    border: 1px solid rgba(242, 243, 247, 1);
    border-radius: 10px;
    padding: 20px;

    &-title {
      font-size: 14px;
      font-weight: bold;
      color: rgba(63, 70, 81, 1);
      margin-bottom: 10px;
    }
    &-answer {
      font-size: 14px;
      font-weight: 400;
      color: rgba(84, 89, 97, 1);
      line-height: 21px;
      white-space: pre-line;
    }
  }
}
</style>
